import { render } from "./MenusColorsCutsom.vue?vue&type=template&id=72e2f9fe&scoped=true"
import script from "./MenusColorsCutsom.vue?vue&type=script&lang=js"
export * from "./MenusColorsCutsom.vue?vue&type=script&lang=js"

import "./MenusColorsCutsom.vue?vue&type=style&index=0&id=72e2f9fe&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e2f9fe"]])

export default __exports__